import React from 'react';
import styled from 'styled-components/native';
import Colors from '../../constants/Colors';
import Button from '../../components/Button';
import { H1, P } from '../../components/Typography';
import { Platform, useWindowDimensions } from 'react-native';
import { useNavigation } from '@react-navigation/core';
import { StackNavigationProp } from '@react-navigation/stack';
import { WelcomeNavigatorParamList } from '../../navigation/WelcomeNavigator';
import elementIDs from '../../../elementIDs';

const StyledScrollView = styled.ScrollView`
  width: 100%;
  height: auto;
  background: ${Colors.primaryPurple};
`;

const StyledImageBackground = styled.ImageBackground<{ isDesktop: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${Platform.OS === 'web' ? 93 : 80}%;
  z-index: -1;
`;

const ContentContainerView = styled.View<{ height: number }>`
  flex-direction: column;
  height: 100%;
  min-height: ${p => p.height}px;
  justify-content: space-between;
  align-items: stretch;
`;

const StyledHeroView = styled.View<{ isDesktop: boolean; isMobile: boolean }>`
  padding: ${p =>
    p.isDesktop
      ? Platform.OS === 'web'
        ? '129px 175px 175px 175px'
        : '129px 175px 250px 175px'
      : '129px 16px 24px 16px'};
  max-width: ${p => (p.isMobile ? 360 : p.isDesktop ? 1080 : 480)}px;
`;

const StyledButton = styled(Button)`
  margin-top: 15px;
  width: 170px;
`;

const StyledH1 = styled(H1)<{ isDesktop: boolean }>`
  font-size: ${p => (p.isDesktop ? 70 : 54)}px;
  margin-right: ${p => (p.isDesktop ? 0 : 75)}px;
  margin-bottom: ${p => (p.isDesktop ? 5 : 0)}px;
  padding-top: ${p => (p.isDesktop ? 10 : 0)}px;
  line-height: 55.86px;
  min-width: ${p => (p.isDesktop ? 295 : 250)}px;
`;

const StyledP = styled(P)`
  font-size: 28px;
  line-height: 32.8px;
  letter-spacing: -0.16px;
  margin: 15px 0 15px 0;
  max-width: 604px;
`;

const WelcomeScreen: React.FC = () => {
  const window = useWindowDimensions();
  const isDesktop = window.width >= 768;
  const isMobile = window.width <= 480;
  const navigation =
    useNavigation<StackNavigationProp<WelcomeNavigatorParamList>>();
  return (
    <StyledScrollView scrollIndicatorInsets={{ right: 1 }}>
      <StyledImageBackground
        isDesktop={isDesktop}
        resizeMode='stretch'
        source={require('../../assets/onboarding/abstract-background-3.png')}
      />
      <ContentContainerView height={window.height}>
        <StyledHeroView isDesktop={isDesktop} isMobile={isMobile}>
          <StyledH1 isDesktop={isDesktop} color='light'>
            Welcome to Chloe
          </StyledH1>
          <StyledP color='light'>
            Let&apos;s start by setting up your account. To begin, there are a
            few things we need to know for Chloe to best support you.
          </StyledP>
          <StyledButton
            outlined
            inverse
            testID={elementIDs.getStartedID}
            onPress={() => {
              navigation.replace('WelcomeSurvey', { sectionIndex: 0 });
            }}
          >
            Get Started
          </StyledButton>
        </StyledHeroView>
      </ContentContainerView>
    </StyledScrollView>
  );
};

export default WelcomeScreen;
